import CustomLabel from "../../../shapes/labels/CustomLabel";
import EventTypes from "../../../shared/EventTypes";
import CustomLabelField from "../../../sidebar/edit/Fields/ElementFields/CustomLabelField";
import AbstractAction from "../AbstractAction";

export default class NewCustomLabelAction extends AbstractAction {
    constructor(provider, labelCollection, index, labelContainer) {
        super(provider);

        this.labelCollection = labelCollection;
        this.index = index;
        this.labelContainer = labelContainer;

        this.label = new CustomLabel(this.provider, { value: '', visible: true });
        this.labelCollection.add(this.label, this.index);
        this.field = new CustomLabelField(this.provider, this.label, this.labelContainer, this.index, this);
        this.input = this.field.input;
        this.labelText = this.field.labelText;
        this.newValue = '';

        this.getTab('info').input.speciesLabelList.add(this.field, this.index);

        this.field.toggleEdit();
    }

    update() {
        this.newValue = this.input.value();
        this.label.text = this.newValue;
    }

    finish() {
        this.labelText.html(this.newValue);
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.labelCollection.parent);
        this.actions.finish();
    }

    undo() {
        this.labelCollection.remove(this.label);
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.labelCollection.parent);
        this.updateInfoTab();
    }

    redo() {
        this.labelCollection.add(this.label, this.index);
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.labelCollection.parent);
        this.updateInfoTab()
    }

    updateInfoTab() {
        let element = this.labelCollection.parent;
        if (this.selection.first == element
            && this.selection.length == 1
        ) {
            this.getTab('info').setCurrentElement(element);
        }
    }

}
